<template>
  <div id="gantt" ref="gantt"></div>
</template>
 
<script>
import { gantt } from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
export default {
  name: "SpeadDomeGantt",

  data() {
    return {};
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      gantt.config.xml_date = "%Y-%m-%d %H:%i";
      gantt.config.scale_height = 50; //设置甘特图的表头高度

      //鼠标移入展示信息

      //时间展示 2021-10-11 07:22
      //   gantt.templates.tooltip_date_format =
      //     gantt.date.date_to_str("%Y-%m-%d %H:%i");
      //   //鼠标移入展示信息
      //   gantt.config.readonly = true; //甘蔗图只读属性
      //   gantt.config.round_dnd_dates = false; //将任务开始时间和结束时间自动“四舍五入'
      //   gantt.config.root_id = "root";
      //   //添加taba栏
      //   gantt.config.columns = [
      //     { name: "name", label: "名称", align: "center", width: 0 },
      //     { name: "age", label: "年龄", align: "center", width: 0 },
      //   ];

      // 语言设置-中文
      gantt.i18n.setLocale("cn");

      // 设置甘特图表格列的最小列宽
      //   gantt.config.mcolumn_width = 20;
      // 设置表格列，name为数据字段，label为表头显示的名称，width为列宽，align为对齐方式
      gantt.config.columns = [
        { name: "cCode", label: "事件", width: 20, align: "center" },
      ];

      // 设置右侧时间刻度相关属性，上方显示年月日，下方显示小时，每个格子代表12小时
      gantt.config.scales = [
        { unit: "day", format: "%m-%d" },
        //   { unit: "day", format: "%Y-%m-%d" },
      ];

      // 设置任务条上展示的内容，参数task会返回当前任务的数据
      gantt.templates.task_text = function (start, end, task) {
        return task.cName;
      };

      gantt.plugins({
        tooltip: true, // 启用 tooltip 插件
      });
      let that = this;
      gantt.templates.tooltip_text = (start, end, task) => {
        if (task.cName) {
          let da =
            that.utils.changeTime(task.start_date) +
            "至" +
            that.utils.changeTime(task.end_date) +
            ":" +
            task.cName;
          return da;
        }
      };

      //   // 禁用任务条链接拖动功能
      gantt.config.drag_links = false;
      //   // 禁用任务条左右边缘拉动功能
      //   gantt.config.drag_resize = false;
      //   // 禁用任务条长按移动功能
      gantt.config.drag_move = false;
      //   // 禁用任务条拖动进度条功能
      gantt.config.drag_progress = false;
      //   // 设置甘特图滚动条的大小为25px
      //   gantt.config.scroll_size = 25;
      //   // 开启表格排序功能
      //   gantt.config.sort = true;
      //   // 渲染发生错误时不显示默认的错误弹框
      gantt.config.show_errors = false;
      gantt.config.grid_width = 42;
      gantt.config.min_column_width = 42;
      gantt.config.min_grid_column_width = 50;
      gantt.config.drag_project = true;
      gantt.config.show_tooltip = true;

      gantt.init(this.$refs.gantt);
      //模拟数据
      let datalist = [
        {
          cCode: "除草",
          id: "f1",
          parent: null,
          render: "split",
        },
        {
          cCode: "施肥",
          id: "f4",
          parent: null,
          render: "split",
        },
        {
          cCode: "杀虫",
          id: "f2",
          parent: null,
          render: "split",
        },

        {
          cCode: "抽雄",
          id: "f3",
          parent: null,
          render: "split",
        },

        {
          cCode: "浇灌",
          id: "f5",
          parent: null,
          render: "split",
        },
        {
          cName: "除草",
          start_date: "2025-5-1",
          end_date: "2025-5-15",
          duration: 1,
          id: "c1",
          parent: "f1",
          render: null,
        },
        {
          cName: "杀虫",
          start_date: "2025-5-15",
          end_date: "2025-5-19",
          duration: 1,
          id: "c2",
          parent: "f2",
          render: null,
        },
        {
          cName: "杀虫",
          start_date: "2025-6-20",
          end_date: "2025-6-26",
          duration: 1,
          id: "c3",
          parent: "f2",
          render: null,
        },
        {
          cName: "杀虫",
          start_date: "2025-7-18",
          end_date: "2025-7-22",
          duration: 1,
          id: "c4",
          parent: "f2",
          render: null,
        },
        {
          cName: "抽雄",
          start_date: "2025-7-5",
          end_date: "2025-7-20",
          duration: 1,
          id: "c5",
          parent: "f3",
          render: null,
        },
        {
          cName: "施肥",
          start_date: "2025-5-15",
          end_date: "2025-5-19",
          duration: 1,
          id: "c6",
          parent: "f4",
          render: null,
        },
        {
          cName: "施肥",
          start_date: "2025-6-2",
          end_date: "2025-6-5",
          duration: 1,
          id: "c7",
          parent: "f4",
          render: null,
        },
        {
          cName: "施肥",
          start_date: "2025-7-3",
          end_date: "2025-7-6",
          duration: 1,
          id: "c8",
          parent: "f4",
          render: null,
        },
        {
          cName: "施肥",
          start_date: "2025-7-28",
          end_date: "2025-8-1",
          duration: 1,
          id: "c9",
          parent: "f4",
          render: null,
        },
		{
		  cName: "浇灌",
		  start_date: "2025-5-10",
		  end_date: "2025-5-18",
		  duration: 1,
		  id: "c10",
		  parent: "f5",
		  render: null,
		},
		{
		  cName: "浇灌",
		  start_date: "2025-5-21",
		  end_date: "2025-5-29",
		  duration: 1,
		  id: "c11",
		  parent: "f5",
		  render: null,
		},
        {
          cName: "浇灌",
          start_date: "2025-6-2",
          end_date: "2025-6-10",
          duration: 1,
          id: "c12",
          parent: "f5",
          render: null,
        },
        {
          cName: "浇灌",
          start_date: "2025-6-13",
          end_date: "2025-6-21",
          duration: 1,
          id: "c13",
          parent: "f5",
          render: null,
        },
        {
          cName: "浇灌",
          start_date: "2025-6-24",
          end_date: "2025-7-2",
          duration: 1,
          id: "c14",
          parent: "f5",
          render: null,
        },
        {
          cName: "浇灌",
          start_date: "2025-7-3",
          end_date: "2025-7-11",
          duration: 1,
          id: "c15",
          parent: "f5",
          render: null,
        },
        {
          cName: "浇灌",
          start_date: "2025-7-14",
          end_date: "2025-7-22",
          duration: 1,
          id: "c16",
          parent: "f5",
          render: null,
        },
        {
          cName: "浇灌",
          start_date: "2025-7-25",
          end_date: "2025-8-3",
          duration: 1,
          id: "c17",
          parent: "f5",
          render: null,
        },{
          cName: "浇灌",
          start_date: "2025-8-4",
          end_date: "2025-8-12",
          duration: 1,
          id: "c18",
          parent: "f5",
          render: null,
        },{
          cName: "浇灌",
          start_date: "2025-8-15",
          end_date: "2025-8-23",
          duration: 1,
          id: "c19",
          parent: "f5",
          render: null,
        },{
          cName: "浇灌",
          start_date: "2025-8-26",
          end_date: "2025-9-4",
          duration: 1,
          id: "c20",
          parent: "f5",
          render: null,
        },{
          cName: "浇灌",
          start_date: "2025-9-7",
          end_date: "2025-9-15",
          duration: 1,
          id: "c21",
          parent: "f5",
          render: null,
        },
      ];
      gantt.parse({ data: datalist });
    },
  },
};
</script>
 
<style lang="scss" scoped>
#gantt {
  height: 227px;
  background: rgba(255, 255, 255, 0) !important;
  overflow: hidden !important;
}
</style>
<style>
.gantt_container,
.gantt_tooltip {
  background: rgba(255, 255, 255, 0) !important;
  color: #fff !important;
  z-index: 9999;
}

.gantt_grid_scale,
.gantt_task_scale,
.gantt_task_vscroll {
  background: rgba(255, 255, 255, 0) !important;
}
.gantt_row,
.gantt_task_row {
  background: rgba(255, 255, 255, 0) !important;
}
.gantt_grid_scale .gantt_grid_head_cell {
  color: #fff;
}
.gantt_task .gantt_task_scale .gantt_scale_cell {
  color: #fff;
}
.gantt_tree_content {
  color: #fff;
}
</style>
